import "core-js/modules/es.array.concat.js";
import layoutHeaderAside from '@/layout/header-aside';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

/**
 * 在主框架内显示
 */
var frameIn = [{
  path: '/',
  redirect: {
    name: 'index'
  },
  component: layoutHeaderAside,
  children: [
  // ///////// //
  // 机构服务 //
  // //////// //
  {
    path: 'lab_mng',
    name: 'lab_mng',
    meta: {
      title: '企业管理',
      auth: true,
      sys: '系统管理'
    },
    component: _import('org/lab_page')
  }, {
    path: 'lab_structures_mng',
    name: 'lab_structures_mng',
    meta: {
      title: '养殖区域管理',
      auth: true,
      sys: '系统管理'
    },
    component: _import('org/lab_area_page')
  }

  // ///////// //
  // 设备管理 //
  // //////// //
  , {
    path: 'device_mng',
    name: 'device_mng',
    meta: {
      title: '采集器管理',
      auth: true,
      sys: '智慧物联'
    },
    component: _import('iot/device_page_mng')
  }, {
    path: 'video_mng',
    name: 'video_mng',
    meta: {
      title: '视频管理',
      auth: true
    },
    component: _import('iot/video/video_page')
  }, {
    path: 'video_up',
    name: 'video_up',
    meta: {
      title: '水上监控',
      auth: true
    },
    component: _import('iot/video/video_up')
  }, {
    path: 'video_down',
    name: 'video_down',
    meta: {
      title: '水下视频',
      auth: true
    },
    component: _import('iot/video/video_down')
  }, {
    path: 'deviceItem_page',
    name: 'deviceItem_page',
    meta: {
      title: '设备参数',
      auth: true
    },
    component: _import('iot/deviceItem_page')
  }, {
    path: 'history_logs',
    name: 'history_logs',
    meta: {
      title: '历史记录',
      auth: true
    },
    component: _import('iot/history_logs_page')
  }, {
    path: 'warn_info',
    name: 'warn_info',
    meta: {
      title: '预警处置',
      auth: true
    },
    component: _import('iot/warn_log_page')
  }
  // ///////// //
  // 生产养殖 //
  // //////// //
  , {
    path: 'task',
    name: 'task',
    meta: {
      title: '养殖任务',
      auth: true
    },
    component: _import('grow/task_page')
  }, {
    path: 'task_breed',
    name: 'task_breed',
    meta: {
      title: '繁育任务',
      auth: true
    },
    component: _import('grow/task_breed')
  }, {
    path: 'task_clean',
    name: 'task_clean',
    meta: {
      title: '清塘任务',
      auth: true
    },
    component: _import('grow/task_clean')
  }, {
    path: 'task_disease',
    name: 'task_disease',
    meta: {
      title: '病害任务',
      auth: true
    },
    component: _import('grow/task_disease')
  }, {
    path: 'task_feed',
    name: 'task_feed',
    meta: {
      title: '投喂任务',
      auth: true
    },
    component: _import('grow/task_feed')
  }, {
    path: 'task_harvest',
    name: 'task_harvest',
    meta: {
      title: '捕捞任务',
      auth: true
    },
    component: _import('grow/task_harvest')
  }, {
    path: 'task_inspection',
    name: 'task_inspection',
    meta: {
      title: '巡塘任务',
      auth: true
    },
    component: _import('grow/task_inspection')
  }, {
    path: 'task_medication',
    name: 'task_medication',
    meta: {
      title: '施药任务',
      auth: true
    },
    component: _import('grow/task_medication')
  }, {
    path: 'task_sample',
    name: 'task_sample',
    meta: {
      title: '采样任务',
      auth: true
    },
    component: _import('grow/task_sample')
  }, {
    path: 'task_split',
    name: 'task_split',
    meta: {
      title: '分塘任务',
      auth: true
    },
    component: _import('grow/task_split')
  }, {
    path: 'task_stock',
    name: 'task_stock',
    meta: {
      title: '投苗任务',
      auth: true
    },
    component: _import('grow/task_stock')
  }, {
    path: 'plan',
    name: 'plan',
    meta: {
      title: '养殖计划',
      auth: true
    },
    component: _import('grow/plan_mng')
  }
  // ///////// //
  // 病害防疫 //
  // //////// //
  , {
    path: 'breed_mng',
    name: 'breed_mng',
    meta: {
      title: '品种管理',
      auth: true
    },
    component: _import('knowledge/breed_page_mng')
  }, {
    path: 'disease_page',
    name: 'disease_page',
    meta: {
      title: '疾病管理',
      auth: true
    },
    component: _import('knowledge/disease_page')
  }, {
    path: 'disease_symptom_page',
    name: 'disease_symptom_page',
    meta: {
      title: '症状管理',
      auth: true
    },
    component: _import('knowledge/disease_symptom_page')
  }, {
    path: 'cms_knowledge',
    name: 'cms_knowledge',
    meta: {
      title: '养殖知识',
      auth: true
    },
    component: _import('knowledge/knowledge_page_mng.vue')
  }, {
    path: 'diseases_common',
    name: 'diseases_common',
    meta: {
      title: '常见疾病',
      auth: true
    },
    component: _import('knowledge/diseases_common_page.vue')
  }, {
    path: 'self_diagnosis',
    name: 'self_diagnosis',
    meta: {
      title: '自助诊断',
      auth: true
    },
    component: _import('knowledge/self_diagnosis_mng')
  }, {
    path: 'areaWarn_page',
    name: 'areaWarn_page',
    meta: {
      title: '地域预警',
      auth: true
    },
    component: _import('knowledge/areaWarn_page')
  }, {
    path: 'cycleWarn_page',
    name: 'cycleWarn_page',
    meta: {
      title: '周期预警',
      auth: true
    },
    component: _import('knowledge/cycleWarn_page')
  }, {
    path: 'stageWarn_page',
    name: 'stageWarn_page',
    meta: {
      title: '阶段预警',
      auth: true
    },
    component: _import('knowledge/stageWarn_page')
  }
  // ///////// //
  // 质量追溯 //
  // //////// //
  , {
    path: 'source_report',
    name: 'source_report',
    meta: {
      title: '溯源报告',
      auth: true
    },
    component: _import('source/source_report_page')
  }, {
    path: 'source_batch',
    name: 'source_batch',
    meta: {
      title: '溯源批次',
      auth: true
    },
    component: _import('source/source_batch_page')
  }, {
    path: 'only_goods',
    name: 'only_goods',
    meta: {
      title: '一物一码',
      auth: true
    },
    component: _import('source/only_goods_mng')
  }, {
    path: 'scan_reocrd',
    name: 'scan_reocrd',
    meta: {
      title: '扫码记录',
      auth: true
    },
    component: _import('source/scan_reocrd_page')
  }
  // ///////// //
  // 投饲机 //
  // //////// //
  , {
    path: 'feed_mng',
    name: 'feed_mng',
    meta: {
      title: '投饲机管理',
      auth: true
    },
    component: _import('iot/feeder/feedBait_mng')
  }
  // ///////// //
  // LED //
  // //////// //
  , {
    path: 'led_mng',
    name: 'led_mng',
    meta: {
      title: 'LED管理',
      auth: true
    },
    component: _import('iot/led/led_page_mng')
  }
  // ///////// //
  // 能耗 //
  // //////// //
  , {
    path: 'monitor_mng',
    name: 'monitor_mng',
    meta: {
      title: '能耗设备管理',
      auth: true
    },
    component: _import('iot/monitor/monitor_page')
  }
  // ///////// //
  // 巡检 //
  // //////// //
  , {
    path: 'inspection_page',
    name: 'inspection_page',
    meta: {
      title: '生产设备',
      auth: true
    },
    component: _import('iot/inspection/inspection_page')
  }, {
    path: 'inspection_task',
    name: 'inspection_task',
    meta: {
      title: '巡检任务',
      auth: true
    },
    component: _import('iot/inspection/inspection_task')
  }
  // ///////// //
  // 控制器 //
  // //////// //
  , {
    path: 'smartControl_mng',
    name: 'smartControl_mng',
    meta: {
      title: '控制器管理',
      auth: true
    },
    component: _import('iot/smartControl/smartControl_mng')
  }
  // ///////// //
  // 驾驶舱数据 //
  // //////// //
  , {
    path: 'nationalProduction',
    name: 'nationalProduction',
    meta: {
      title: '全国产量',
      auth: true
    },
    component: _import('mng/nationalProduction_page')
  }, {
    path: 'provincialProduction',
    name: 'provincialProduction',
    meta: {
      title: '省份产量',
      auth: true
    },
    component: _import('mng/provincialProduction_page')
  }, {
    path: 'labProduction',
    name: 'labProduction',
    meta: {
      title: '企业产量',
      auth: true
    },
    component: _import('mng/labProduction_page')
  }, {
    path: 'marketPrice',
    name: 'marketPrice',
    meta: {
      title: '市场价格',
      auth: true
    },
    component: _import('mng/marketPrice_page')
  }, {
    path: 'marketSpecPrice_page',
    name: 'marketSpecPrice_page',
    meta: {
      title: '市场规格价格',
      auth: true
    },
    component: _import('mng/marketSpecPrice_page')
  }, {
    path: 'regionalSales',
    name: 'regionalSales',
    meta: {
      title: '地区销量',
      auth: true
    },
    component: _import('mng/regionalSales_page')
  }, {
    path: 'labSpecies',
    name: 'labSpecies',
    meta: {
      title: '养殖品种',
      auth: true
    },
    component: _import('mng/labSpecies_page')
  }

  // ///////// //
  // 用户权限 //
  // //////// //
  , {
    path: 'user_menu',
    name: 'user_menu',
    meta: {
      title: '菜单管理',
      auth: true
    },
    component: _import('user/menu_page')
  }, {
    path: 'user_role',
    name: 'user_role',
    meta: {
      title: '角色管理',
      auth: true
    },
    component: _import('user/role_page')
  }, {
    path: 'mng_admin',
    name: 'mng_admin',
    meta: {
      title: '用户管理',
      auth: true
    },
    component: _import('user/admin_page')
  }
  // ///////// //
  // 系统管理 //
  // //////// //
  , {
    path: 'sys_dictionary',
    name: 'sys_dictionary',
    meta: {
      title: '字典管理',
      auth: true
    },
    component: _import('sys/dictionary_page')
  }, {
    path: 'sys_config',
    name: 'sys_config',
    meta: {
      title: '配置管理',
      auth: true
    },
    component: _import('sys/config_page')
  }, {
    path: 'sys_switch',
    name: 'sys_switch',
    meta: {
      title: '开关管理',
      auth: true
    },
    component: _import('sys/switch_page')
  }, {
    path: 'sys_about',
    name: 'sys_about',
    meta: {
      title: '关于系统',
      auth: true
    },
    component: _import('sys/about_page')
  }, {
    path: 'sys_file',
    name: 'sys_file',
    meta: {
      title: '文件管理',
      auth: true
    },
    component: _import('sys/file_page')
  }, {
    path: 'sys_lbs',
    name: 'sys_lbs',
    meta: {
      title: '行政区划',
      auth: true
    },
    component: _import('sys/lbs_page')
  }, {
    path: 'thirdCert_page',
    name: 'thirdCert_page',
    meta: {
      title: '应用授权',
      auth: true
    },
    component: _import('sys/thirdCert_page')
  }

  // ///////// //
  // 内容管理 //
  // //////// //
  , {
    path: 'cms_article_simple',
    name: 'cms_article_simple',
    meta: {
      title: '文章管理',
      auth: true
    },
    component: _import('cms/article_simple_page')
  }, {
    path: 'cms_notice',
    name: 'cms_notice',
    meta: {
      title: '公告管理',
      auth: true
    },
    component: _import('cms/notice_page')
  }, {
    path: 'cms_advertising',
    name: 'cms_advertising',
    meta: {
      title: '广告管理',
      auth: true
    },
    component: _import('cms/advertising_page')
  }, {
    path: 'cms_carousel',
    name: 'cms_carousel',
    meta: {
      title: '轮播管理',
      auth: true
    },
    component: _import('cms/carousel_page')
  }, {
    path: 'cms_feedback',
    name: 'cms_feedback',
    meta: {
      title: '反馈管理',
      auth: true
    },
    component: _import('cms/feedback_page')
  }, {
    path: 'cms_work_order',
    name: 'cms_work_order',
    meta: {
      title: '在线诊断',
      auth: true
    },
    component: _import('cms/work_order_page')
  }, {
    path: 'dataroom',
    name: 'dataroom',
    meta: {
      title: '大屏设计器',
      auth: true
    },
    component: _import('sys/design')
  }
  // /////// //
  // 官网管理 //
  // ////// //
  , {
    path: 'website_navigation_article',
    name: 'website_navigation_article',
    meta: {
      title: '导航文章',
      auth: true
    },
    component: _import('website/navigation_article/navigation_article_mng_page')
  }, {
    path: 'website_outlink',
    name: 'website_outlink',
    meta: {
      title: '外链管理',
      auth: true
    },
    component: _import('website/outlink_page')
  }, {
    path: 'baiduAI',
    name: 'baiduAI',
    meta: {
      title: 'AI渔业平台小助手',
      auth: true
    },
    component: _import('sys/baiduAI')
  }
  // ///////// //
  // 记录管理 //
  // //////// //
  , {
    path: 'app_version',
    name: 'app_version',
    meta: {
      title: 'APP版本',
      auth: true
    },
    component: _import('record/app_version_page')
  }, {
    path: 'record_log',
    name: 'record_log',
    meta: {
      title: '日志管理',
      auth: true
    },
    component: _import('record/log_page')
  }, {
    path: 'db_bak',
    name: 'db_bak',
    meta: {
      title: '数据库备份',
      auth: true
    },
    component: _import('record/db_bak_page')
  }
  // /////// //
  // 示例功能 //
  // ////// //
  , {
    path: 'demo_echarts',
    name: 'demo_echarts',
    meta: {
      title: 'Echarts',
      auth: true
    },
    component: _import('demo/echarts')
  }, {
    path: 'demo_bmap',
    name: 'demo_bmap',
    meta: {
      title: 'BMap',
      auth: true
    },
    component: _import('demo/bmap')
  }
  // /////// //
  // 其他功能 //
  // ////// //
  , {
    // 系统 前端日志
    path: 'log',
    name: 'log',
    meta: {
      title: '前端日志',
      auth: true
    },
    component: _import('system/log')
  }, {
    // 刷新页面 必须保留
    path: 'refresh',
    name: 'refresh',
    hidden: true,
    component: _import('system/function/refresh')
  }, {
    // 页面重定向 必须保留
    path: 'redirect/:route*',
    name: 'redirect',
    hidden: true,
    component: _import('system/function/redirect')
  }]
}];

/**
 * 在主框架之外显示
 */
var frameOut = [
// 登录
{
  path: '/login',
  name: 'login',
  component: _import('system/login')
}, {
  path: '/index',
  name: 'index',
  meta: {
    title: '首页',
    auth: true
  },
  component: _import('system/index')
}, {
  path: '/largeEnergy',
  name: 'largeEnergy',
  meta: {
    title: '装备能耗',
    auth: true
  },
  component: _import('system/index/largeEnergy')
}, {
  path: '/largeWater',
  name: 'largeWater',
  meta: {
    title: '驾驶舱',
    auth: true
  },
  component: _import('system/index/largeWater')
}, {
  path: '/largeWater_tlf',
  name: 'largeWater_tlf',
  meta: {
    title: '驾驶舱',
    auth: true
  },
  component: _import('system/index/largeWater_tlf')
}, {
  path: '/largeDevice',
  name: 'largeDevice',
  meta: {
    title: '智慧物联',
    auth: true
  },
  component: _import('system/index/largeDevice')
}, {
  path: '/largeVideo',
  name: 'largeVideo',
  meta: {
    title: '视频监控',
    auth: true
  },
  component: _import('system/index/largeVideo')
}, {
  path: '/largeProduct',
  name: 'largeProduct',
  meta: {
    title: '生产管理',
    auth: true
  },
  component: _import('system/index/largeProduct')
}, {
  path: '/largeFanli',
  name: 'largeFanli',
  meta: {
    title: '范蠡模型',
    auth: true
  },
  component: _import('system/index/largeFanli')
}, {
  path: '/digitalTwin',
  name: 'digitalTwin',
  meta: {
    title: '数字孪生',
    auth: true
  },
  component: _import('system/index/digitalTwin')
}, {
  path: '/largeSource',
  name: 'largeSource',
  meta: {
    title: '质量溯源',
    auth: true
  },
  component: _import('system/index/largeSource')
}, {
  path: '/largeDisease',
  name: 'largeDisease',
  meta: {
    title: '病害防疫',
    auth: true
  },
  component: _import('system/index/largeDisease')
}, {
  path: '/largeFeed',
  name: 'largeFeed',
  meta: {
    title: '精准投喂',
    auth: true
  },
  component: _import('system/index/largeFeed')
}, {
  path: '/largeAeration',
  name: 'largeAeration',
  meta: {
    title: '智能增氧',
    auth: true
  },
  component: _import('system/index/largeAeration')
}, {
  path: '/knowledge',
  name: 'knowledge',
  meta: {
    title: '知识库',
    auth: true
  },
  component: _import('knowledge/knowledge_page_mng.vue')
}, {
  path: '/diagnosis',
  name: 'diagnosis',
  meta: {
    title: '自助诊断',
    auth: true
  },
  component: _import('knowledge/self_diagnosis_mng')
}, {
  path: '/largeInspection',
  name: 'largeInspection',
  meta: {
    title: '自动巡检',
    auth: true
  },
  component: _import('system/index/largeInspection')
}, {
  path: '/largeCockpit',
  name: 'largeCockpit',
  meta: {
    title: '市驾驶舱',
    auth: true
  },
  component: _import('system/index/largeCockpit')
}, {
  path: '/login_code',
  name: 'login_code',
  meta: {
    title: '微信登录',
    auth: false
  },
  component: _import('system/login/login_code')
}, {
  path: '/bind_code',
  name: 'bind_code',
  meta: {
    title: '绑定微信',
    auth: false
  },
  component: _import('system/login/bind_code')
}, {
  path: '/listening_camera',
  name: 'listening_camera',
  meta: {
    title: '摄像头视频播放',
    auth: false
  },
  component: _import('system/listening_camera')
}];

/**
 * 错误页面
 */
var errorPage = [{
  path: '*',
  name: '404',
  component: _import('system/error/404')
}, {
  path: '*',
  name: '411',
  component: _import('system/error/411')
}];

// 导出需要显示菜单的
export var frameInRoutes = frameIn;

// 重新组织后导出
export default [].concat(frameIn, frameOut, errorPage);